import { NAME } from './constants';
import routes from './routes';

export default {
  NAME, routes
};
